/* eslint import/export: 0 */
import Login from '@/app/pages/Login/Index'
import Callback from '@/app/components/Callback'
import Page404 from '@/app/components/404'
import Dashboard from '@/app/pages/Dashboard/Index'
import User from '@/app/pages/User/Index'
import LinkToDeal from '@/app/pages/User/LinkToDeal'
import UserMetrics from '@/app/pages/Metrics/User'
import TransactionMetrics from '@/app/pages/Metrics/Transactions'
import CashbackMetrics from '@/app/pages/Metrics/Cashback'
import ClaimsMetrics from '@/app/pages/Metrics/Claims'
import PopularDeals from '@/app/pages/Metrics/PopularDeals'
import TransactionLog from '@/app/pages/Logs/Transactions'
import DealAlert from '@/app/pages/Alerts/DealAlert'
import Outbox from '@/app/pages/Localdeals/Outbox'

// Routes
const routes = [
  // {
  //  path: '/',
  //  name: 'sso.index',
  //  component: SSO,
  //  meta: {
  //    auth: false,
  //    permission: 'any',
  //    fail: '/login'
  //  }
  // },
  {
    path: '/',
    name: 'dashboard.index',
    component: Dashboard,
    meta: {
      group: 'Customers',
      auth: true,
      permission: 'any',
      fail: '/login',
      breadcrumb: 'Dashboard'
    },
    children: [
      {
        path: '',
        name: 'user.index',
        component: User,
        meta: {
          group: 'Customers',
          auth: true,
          permission: 'IT|it_admin',
          fail: '/login',
          breadcrumb: 'Customer Details'
        }
      },
      {
        path: 'user-link',
        name: 'user.link',
        component: LinkToDeal,
        meta: {
          group: 'Customers',
          auth: true,
          permission: 'IT|it_admin',
          fail: '/login',
          breadcrumb: 'Link customer to deal'
        }
      },
      {
        path: 'user-metrics',
        name: 'metrics.user',
        component: UserMetrics,
        meta: {
          group: 'Metrics',
          auth: true,
          permission: 'IT|it_admin',
          fail: '/login',
          breadcrumb: 'Customer Metrics'
        }
      },
      {
        path: 'transactions-metrics',
        name: 'metrics.transactions',
        component: TransactionMetrics,
        meta: {
          group: 'Metrics',
          auth: true,
          permission: 'IT|it_admin',
          fail: '/login',
          breadcrumb: 'Transaction Metrics'
        }
      },
      {
        path: 'cashback-metrics',
        name: 'metrics.cashback',
        component: CashbackMetrics,
        meta: {
          group: 'Metrics',
          auth: true,
          permission: 'IT|it_admin',
          fail: '/login',
          breadcrumb: 'Cashback Metrics'
        }
      },
      {
        path: 'claims-metrics',
        name: 'metrics.claims',
        component: ClaimsMetrics,
        meta: {
          group: 'Metrics',
          auth: true,
          permission: 'IT|it_admin',
          fail: '/login',
          breadcrumb: 'Claims Metrics'
        }
      },
      {
        path: 'popular-deals',
        name: 'metrics.popular',
        component: PopularDeals,
        meta: {
          group: 'Metrics',
          auth: true,
          permission: 'IT|it_admin',
          fail: '/login',
          breadcrumb: 'Popular deals'
        }
      },
      {
        path: 'transaction-log',
        name: 'log.transactions',
        component: TransactionLog,
        meta: {
          group: 'Logs',
          auth: true,
          permission: 'IT|it_admin',
          fail: '/login',
          breadcrumb: 'Transaction Log'
        }
      },
      {
        path: 'deal-alerts',
        name: 'alerts.deals',
        component: DealAlert,
        meta: {
          group: 'Alerts',
          auth: true,
          permission: 'IT|it_admin',
          fail: '/login',
          breadcrumb: 'Deal Alerts'
        }
      },
      {
        path: 'outbox-deals',
        name: 'outbox.deals',
        component: Outbox,
        meta: {
          group: 'Localdeals',
          auth: true,
          permission: 'IT|it_admin',
          fail: '/login',
          breadcrumb: 'Outbox'
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'login.index',
    component: Login,
    meta: {
      auth: false,
      permission: 'any',
      fail: '/login'
    }
  },
  {
    path: '/callback',
    component: Callback,
    meta: {
      auth: false,
      permission: 'any',
      fail: '/'
    }
  },
  {
    // not found handler
    path: '*',
    name: '404',
    component: Page404,
    meta: {
      auth: false,
      permission: 'any',
      fail: '/'
    }
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/app/routes.js